import { FormHelperText, Grid, Typography } from "@mui/material";
import moment from "moment/moment";
import { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { useReactToPrint } from "react-to-print";
import CustomButton from "../../../../components/CustomButton";
import CustomCheckbox from "../../../../components/CustomCheckbox";
import CustomModal from "../../../../components/CustomModal/CustomModal";
import Table from "../../../../components/CustomTable";
import CustomTextField from "../../../../components/CustomTextField";
import CustomUpload from "../../../../components/CustomUpload";
import {
  default as CustomSelect,
  default as Select,
} from "../../../../components/Select/Select";
import { getClinicStocks } from "../../../../redux/reducers/clinicSlice";
import {
  createPreventive,
  deletePreventive,
  getFilterdPetPreventives,
  getPetPreventives,
  updatePreventive,
} from "../../../../redux/reducers/petSlice";
import {
  preventiveTypes,
  radioActionScheduleOnly,
  radioActionTypes,
} from "../../../../util/arrayList";
import { downloadTypeList } from "../../../../util/dropList";
import { datePlusOneDay, getDateDiffInDays } from "../../../../util/function";
import FilesWithCloseButton from "./FilesWithCloseButton";

const nameExpan = {
  type: "Select Type",
  name: "Vaccine Name",
  dueDate: "Due Date",
  remarks: "Remarks",
  nextDueDate: "Next Due Date",
};

const initialValues = {
  editable: true,
  actionType: "Schedule",
  type: preventiveTypes?.[2],
  name: "",
  stockId: null,
  batchNo: null,
  dueDate: new Date(),
  remarks: "",
  files: [],
  nextDosage: "No",
  nextDueDate: null,
};

const tableHeaders = [
  "type",
  "name",
  "date",
  "remark",
  // "file",
  "status",
  // "preventiveImage",
];

const initialErrors = {
  type: false,
  name: false,
  dueDate: false,
  remarks: false,
};

const initialHelpers = {
  type: "",
  name: "",
  dueDate: "",
  remarks: "",
};

const initDownValues = {
  startDate: new Date(),
  endDate: new Date(),
};

const Preventive = ({ setScrollable }) => {
  const location = useLocation();
  const dispatch = useDispatch();
  const { appointment } = location.state || {};
  const contentToPrint = useRef(null);
  const [isEditModal, setEditModal] = useState(false);
  const [delModVsble, setDelModVsble] = useState(false);
  const [preventiveId, setPreventiveId] = useState(null);
  const [prevent, setPrevent] = useState(null);
  const [preventiveErrors, setPreventiveErrors] = useState(initialErrors);
  const [preventiveHelpers, setPreventiveHelpers] = useState(initialHelpers);
  const [preventiveValues, setPreventiveValues] = useState(initialValues);
  const [searchText, setSearchText] = useState("");
  const [type, setType] = useState("Completed");
  const [attachModVisible, setAttachModVisible] = useState(false);
  const [attachments, setAttachments] = useState(null);
  const [page, setPage] = useState(1);
  const [modVisible, setModVisible] = useState(false);
  const [vaccineList, setVaccineList] = useState([]);
  const [dewormingList, setDewormingList] = useState([]);
  const [fleaTreatmentList, setFleaTreatmentList] = useState([]);
  const [downloadModVsble, setDownloadModVsble] = useState(false);
  const [downloadTypes, setDownloadTypes] = useState([
    "vaccination",
    "fleaTreatment",
    "deworming",
  ]);
  const [downType, setDownType] = useState("Vaccine certificate");
  const [downloadValues, setDownloadValues] = useState(initDownValues);
  const [typeNotSelected, setTypeNotSelected] = useState(false);
  const [preViewModVsble, setPreViewModVsble] = useState(false);
  const [previewSingleData, setPreviewSingleData] = useState([]);
  const [conModVsble, setConModVsble] = useState(false);
  const { preventives, filteredPreventives } = useSelector(
    (state) => state?.pet
  );
  const stocks = useSelector((state) => state?.clinic?.clinicStocks);
  const petDetails = useSelector((state) => state?.pet?.petDetails);
  const apntDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const appointmentId = appointment?.appoinment?.appointmentId;
  const petDet = appointmentId ? apntDet?.pet : petDetails;
  const statusActive =
    typeof petDet?.status === "boolean"
      ? petDet?.status
      : petDet?.status === "Y";
  const itemsPerLoad = 10;
  const defaultUrl = `?page=1&itemSize=${itemsPerLoad}`;
  const user = localStorage.getItem("user");
  const clinicProfile = JSON.parse(user);

  useEffect(() => {
    setScrollable(false);
    dispatch(
      getPetPreventives({
        petId: appointment?.appoinment?.petId,
        url: defaultUrl,
      })
    );
    dispatch(getClinicStocks());
  }, []);

  useEffect(() => {
    setPreventiveValues({
      ...preventiveValues,
      actionType:
        apntDet?.appointment?.appointmentStatus === "consultation" ||
        apntDet?.appointment?.appointmentStatus === "finalize"
          ? "Administer"
          : "Schedule",
    });
  }, [apntDet?.appointment?.appointmentStatus]);

  const handleModClose = () => {
    setModVisible(!modVisible);
    setEditModal(false);
    setPreventiveValues(initialValues);
    setPreventiveErrors(initialErrors);
    setPreventiveHelpers(initialHelpers);
    setPrevent(null);
  };

  const handleEditModal = (prevent, editable) => {
    setPrevent(prevent);
    const reqObj = {
      ...initialValues,
      editable,
      actionType: prevent?.status === "Pending" ? "Schedule" : "Administer",
      type: preventiveTypes?.find(
        (typ) =>
          typ?.value ===
          (prevent?.type === "Vaccines"
            ? "vaccination"
            : prevent?.type === "Flea & Tick Treatment"
            ? "fleaTreatment"
            : prevent?.type === "Deworming"
            ? "deworming"
            : prevent?.type)
      ),
      name: prevent?.name,
      stockId: prevent?.stockId,
      dueDate: new Date(prevent?.date),
      oldDueDate: new Date(prevent?.date),
      remarks: prevent?.remark,
      files: prevent?.file?.map((fle) => ({ file: null, previewUrl: fle })),
    };
    const reqPre = (
      prevent?.type === "vaccination"
        ? vaccineList
        : prevent?.type === "deworming"
        ? dewormingList
        : prevent?.type === "fleaTreatment"
        ? fleaTreatmentList
        : []
    )?.find((li) => li?.name === prevent?.name);
    if (reqPre) {
      reqObj.serviceId = reqPre?.serviceId;
      reqObj.productId = reqPre?.productId;
    }

    setPreventiveValues(reqObj);
    setModVisible(true);
    setEditModal(true);
  };

  const handleChangeValues = (name, value, addObj) => {
    const reqValue = typeof value === "object" ? value?.value : value;
    const reqObj = { ...preventiveValues, [name]: value };
    if (name === "type") reqObj.name = null;
    if (name === "name" && addObj) {
      reqObj.stockId = addObj?.stockId;
    }
    if (name === "batchNo" && addObj) {
      reqObj.batchId = addObj?.batchId;
    }
    if (name === "actionType") {
      reqObj.dueDate =
        value === "Administer"
          ? new Date()
          : preventiveValues?.oldDueDate ?? new Date();
      reqObj.oldDueDate =
        preventiveValues?.oldDueDate ?? preventiveValues?.dueDate ?? new Date();
    }
    if (addObj?.productId) reqObj.productId = addObj?.productId;
    if (addObj?.serviceId) reqObj.serviceId = addObj?.serviceId;
    setPreventiveValues(reqObj);
    setPreventiveErrors({
      ...preventiveErrors,
      [name]: reqValue?.length ? false : true,
    });
    setPreventiveHelpers({
      ...preventiveHelpers,
      [name]:
        reqValue?.length > 0
          ? ""
          : name === "name"
          ? `${
              preventiveValues?.type?.value === "vaccination"
                ? "Vaccination"
                : preventiveValues?.type?.value === "deworming"
                ? " Deworming"
                : "Flea"
            } name is required`
          : `${nameExpan?.[name]} is required`,
    });
    if (name === "nextDueDate") {
      setPreventiveErrors({
        ...preventiveErrors,
        [name]: value ? false : true,
      });
      setPreventiveHelpers({
        ...preventiveHelpers,
        [name]: value ? "" : "Next Due Date is required",
      });
    }
  };

  const handleSuccess = () => {
    dispatch(
      getPetPreventives({
        petId: appointment?.appoinment?.petId,
        url: defaultUrl,
      })
    );
    setPage(1);
    handleModClose();
    setPreventiveValues(initialValues);
    setPreventiveErrors(initialErrors);
    setPreventiveHelpers(initialHelpers);
    setConModVsble(false);
  };

  const handleSave = () => {
    const err = {};
    const hlp = {};
    if (!preventiveValues?.type) {
      err.type = true;
      hlp.type = "Type is required";
    }
    if (preventiveValues?.name === "" || preventiveValues?.name === null) {
      err.name = true;
      hlp.name = `${
        preventiveValues?.type?.value === "vaccination"
          ? "Vaccination"
          : preventiveValues?.type?.value === "deworming"
          ? " Deworming"
          : "Flea"
      } name is required`;
    }
    if (!preventiveValues?.dueDate || preventiveValues?.dueDate === undefined) {
      err.dueDate = true;
      hlp.dueDate = "Due Date is required";
    }
    if (
      preventiveValues?.actionType === "Administer" &&
      preventiveValues?.nextDosage === "Yes"
    ) {
      if (
        !preventiveValues?.nextDueDate ||
        preventiveValues?.nextDueDate === undefined
      ) {
        err.nextDueDate = true;
        hlp.nextDueDate = "Next Due Date is required";
      }
    }
    if (preventiveValues?.actionType === "Administer") {
      if (!preventiveValues?.batchNo) {
        err.batchNo = true;
        hlp.batchNo = "Batch Number is required";
      }
    }

    if (Object.keys(err).length > 0) {
      setPreventiveErrors({ ...preventiveErrors, ...err });
      setPreventiveHelpers({ ...preventiveHelpers, ...hlp });
      return;
    }
    if (
      isEditModal &&
      preventiveValues?.actionType === "Administer" &&
      getDateDiffInDays(
        preventiveValues?.dueDate,
        preventiveValues?.oldDueDate
      ) > 30
    ) {
      return setConModVsble(true);
    }
    handleApiCall();
  };

  const handleApiCall = () => {
    const form = new FormData();
    if (isEditModal) {
      form.append("appId", appointmentId);
    }
    form.append("type", preventiveValues?.type?.value);
    form.append("name", preventiveValues?.name);
    form.append("stockId", preventiveValues?.stockId);
    form.append(
      "date",
      moment(new Date(preventiveValues?.dueDate)).format("YYYY-MM-DD")
    );
    form.append("remark", preventiveValues?.remarks);
    form.append(
      "status",
      preventiveValues?.actionType === "Schedule" ? "Pending" : "Completed"
    );
    form.append("inpatient", false);
    form.append(
      "administered",
      preventiveValues?.actionType === "Schedule" ? false : true
    );
    if (preventiveValues?.actionType === "Administer") {
      form.append("batchNo", preventiveValues?.batchNo);
      form.append("batchId", preventiveValues?.batchId);
    }
    if (prevent?.preventiveId) form.append("detailId", prevent?.preventiveId);

    if (
      preventiveValues?.type?.value === "vaccination" &&
      preventiveValues?.files?.length > 0
    ) {
      preventiveValues?.files?.forEach((fle) => {
        form.append("files", fle?.file ?? fle?.previewUrl);
      });
    }
    if (!isEditModal) {
      dispatch(createPreventive({ appointmentId, form })).then((res) => {
        if (res?.payload?.status === 200) {
          if (
            preventiveValues?.actionType === "Administer" &&
            preventiveValues?.nextDosage === "Yes"
          ) {
            form.delete("status");
            form.delete("date");
            form.append("status", "Pending");
            form.append(
              "date",
              moment(new Date(preventiveValues?.nextDueDate)).format(
                "YYYY-MM-DD"
              )
            );
            dispatch(createPreventive({ appointmentId, form })).then(
              (secRes) => {
                if (secRes?.payload?.status === 200) handleSuccess();
              }
            );
            return;
          }
          handleSuccess();
          setConModVsble(false);
        }
      });
    } else {
      dispatch(
        updatePreventive({ preventId: prevent?.preventiveId, form })
      ).then((res) => {
        if (res?.payload?.status === 200) {
          if (
            preventiveValues?.actionType === "Administer" &&
            preventiveValues?.nextDosage === "Yes"
          ) {
            form.delete("status");
            form.delete("date");
            form.delete("batchNo");
            form.delete("batchId");
            form.delete("appId");
            form.append("status", "Pending");
            form.append(
              "date",
              moment(new Date(preventiveValues?.nextDueDate)).format(
                "YYYY-MM-DD"
              )
            );
            dispatch(createPreventive({ appointmentId, form })).then(
              (secRes) => {
                if (secRes?.payload?.status === 200) handleSuccess();
              }
            );
            return;
          }
          dispatch(
            getPetPreventives({
              petId: appointment?.appoinment?.petId,
              url: defaultUrl,
            })
          );
          setPage(1);
          handleModClose();
          setPreventiveValues(initialValues);
          setConModVsble(false);
        }
      });
    }
  };

  const handleChangePage = (e, selectedPage) => {
    dispatch(
      getPetPreventives({
        petId: appointment?.appoinment?.petId,
        url: `?page=${selectedPage}&itemSize=${itemsPerLoad}`,
      })
    );
    setPage(selectedPage);
  };

  const onDownloadModClose = () => {
    setDownloadModVsble(false);
    // setDownloadTypes([]);
    setDownloadValues(initDownValues);
    setTypeNotSelected(false);
  };

  const handleChangeCheckboxValue = (name, value) => {
    const prevType = downloadTypes?.find((typ) => typ === name);
    if (prevType) {
      const reqList = downloadTypes?.filter((typ) => typ !== name);
      setDownloadTypes(reqList);
      setTypeNotSelected(reqList?.length > 0 ? false : true);
    } else {
      setDownloadTypes([...downloadTypes, name]);
      setTypeNotSelected(false);
    }
  };

  const handleChangeDownValues = (e) => {
    const { name, value } = e?.target;
    setDownloadValues({ ...downloadValues, [name]: value });
  };

  const handlePreview = () => {
    if (downloadTypes?.length === 0) return setTypeNotSelected(true);
    const url = `?filter=${downloadTypes?.toString()}&startDate=${moment(
      new Date(downloadValues?.startDate)
    ).format("YYYY-MM-DD")}&endDate=${moment(
      new Date(downloadValues?.endDate)
    ).format("YYYY-MM-DD")}`;
    dispatch(
      getFilterdPetPreventives({
        petId: appointment?.appoinment?.petId,
        url,
      })
    );
    setPreViewModVsble(true);
  };

  const onClosePreViewMod = () => {
    setPreViewModVsble(false);
    // setDownloadTypes([]);
    setPreviewSingleData([]);
  };

  const getPreventiveByType = (typ) => {
    return previewSingleData?.length > 0
      ? previewSingleData?.filter((pre) =>
          pre?.type?.toLowerCase() === "vaccines"
            ? "vaccination"
            : pre?.type?.toLowerCase() === typ
        )
      : filteredPreventives?.data?.filter((pre) =>
          pre?.type?.toLowerCase() === "vaccines"
            ? "vaccination"
            : pre?.type?.toLowerCase() === typ && pre?.status === "Completed"
        );
  };

  const renderRecord = (list) => {
    return list?.map((li, i) => {
      const batchDet = getBatchDetail(li?.stockId, li?.batchId) ?? null;

      return (
        <div className="gray-back-con1 mv5" key={Date.now() + i}>
          <div className="flex-row-ali-cen flex-row-wrap">
            <Typography className="txt-semi-bold black fs12">
              Product Name: {li?.name}
            </Typography>
            <div className="gray-dot2 mh5" />
            <Typography className="font-medium black4 fs12">
              Batch No:
            </Typography>
            <Typography className="txt-regular black4 fs12 ml5">
              {batchDet?.batchNo ?? ""}
            </Typography>
            <div className="gray-dot2 mh5" />
            <Typography className="font-medium black4 fs12">
              Mfg Date:
            </Typography>
            <Typography className="txt-regular black4 fs12 ml5">
              {moment(batchDet?.mfgDate ?? new Date()).format("DD MMM YYYY")}
            </Typography>
            <div className="gray-dot2 mh5" />
            <Typography className="font-medium black4 fs12">
              Exp Date:
            </Typography>
            <Typography className="txt-regular black4 fs12 ml5">
              {moment(batchDet?.expiryDate ?? new Date()).format("DD MMM YYYY")}
            </Typography>
          </div>
          <div className="flex-row-ali-cen mt5 flex-row-wrap">
            <div className="gray-dot2 mr5" />
            <Typography className="font-medium black4 fs12">
              Administered date & by:
            </Typography>
            <div className="flex-row">
              <Typography className="txt-regular black4 fs12 ml5 capitalize">
                {moment(new Date(li?.date)).format("DD MMM YYYY")}
              </Typography>
              {li?.doctorName?.length > 0 ? (
                <div className="flex-row">
                  <div className="txt-regular black4 fs12 ml5 capitalize">
                    | {li?.doctorId === li?.clinicId ? "" : "Dr. "}
                    {li?.doctorName}
                  </div>
                  {li?.registrationNo?.length > 0 ? (
                    <div className="flex-row-ali-cen">
                      <div className="font-regular fs12 black ml5">(</div>
                      <div className="font-medium black4 fs12 ml2">RegNo:</div>
                      <div className="font-regular fs12 black ml5 capitalize">
                        {li?.registrationNo} )
                      </div>
                    </div>
                  ) : null}
                </div>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
      );
    });
  };

  const handlePrint = useReactToPrint({
    documentTitle: `Preventive History-${apntDet?.pet?.petName}-${
      previewSingleData?.length > 0
        ? `${moment(previewSingleData?.[0]?.date).format("DD MMM YYYY")}`
        : `${moment(new Date(downloadValues?.startDate)).format(
            "DD MMM YYYY"
          )}-${moment(new Date(downloadValues?.endDate)).format("DD MMM YYYY")}`
    }`,
    removeAfterPrint: true,
  });

  // const handleDownloadPreventive = () => {
  //   const url = `${baseURL}/export/preventive?petId=${
  //     appointment?.appoinment?.petId
  //   }&filter=${downloadTypes?.toString()}&startDate=${moment(
  //     new Date(downloadValues?.startDate)
  //   ).format("YYYY-MM-DD")}&endDate=${moment(
  //     new Date(downloadValues?.endDate)
  //   ).format("YYYY-MM-DD")}`;
  //   window.open(url, "_blank");
  // };

  const handleViewPreventive = (data) => {
    setPreviewSingleData([data]);
    handleChangeCheckboxValue(data?.type);
    setPreViewModVsble(true);
  };

  const getTypeBasedList = () => {
    const reqList = stocks?.data?.filter((dta) => {
      return (
        dta?.billable &&
        // dta?.stockBatch?.find((btch) => btch?.billlable === "Y") &&
        dta?.category?.toLowerCase() ===
          (preventiveValues?.type?.value?.toLowerCase() === "vaccination"
            ? "vaccines"
            : preventiveValues?.type?.value?.toLowerCase() === "fleatreatment"
            ? "flea & tick treatment"
            : preventiveValues?.type?.value?.toLowerCase())
      );
    });
    return reqList?.map((li) => ({
      name: li?.tradeName,
      value: li?.tradeName,
      stockId: li?.stockId,
      productName: li?.productName,
    }));
  };

  const getBatchList = () => {
    if (!preventiveValues?.stockId) return [];
    const reqStock = stocks?.data?.find(
      (stc) => stc?.stockId === preventiveValues?.stockId
    );
    const filteredBatches = reqStock?.stockBatch?.map((btch) => ({
      name: btch?.batchNo,
      value: btch?.batchNo,
      batchId: btch?.batchId,
    }));
    return filteredBatches;
  };

  const getBatchDetail = (stockId, batchId) => {
    if (!stockId && !batchId) return null;
    const reqStock = stocks?.data?.find((stc) => stc?.stockId === stockId);
    const filteredBatches = reqStock?.stockBatch?.find(
      (btch) => btch?.batchId === batchId
    );
    return filteredBatches;
  };

  const handleCloseConMod = () => {
    setConModVsble(false);
  };

  const handleConCancel = () => {
    setConModVsble(false);
    setModVisible(!modVisible);
    setEditModal(false);
    setPreventiveValues(initialValues);
    setPreventiveErrors(initialErrors);
    setPreventiveHelpers(initialHelpers);
    setPrevent(null);
  };

  const handleCloseDelMod = () => {
    setDelModVsble(false);
    setPreventiveId(null);
  };

  const handleDelete = (item) => {
    setPreventiveId(item?.preventiveId);
    setDelModVsble(true);
  };

  const handleDeletePreventive = () => {
    dispatch(deletePreventive(preventiveId)).then((res) => {
      if (res?.payload) {
        dispatch(
          getPetPreventives({
            petId: appointment?.appoinment?.petId,
            url: defaultUrl,
          })
        );
        handleCloseDelMod();
      }
    });
  };

  const onUploadFile = (e) => {
    const fileList = e?.target?.files;
    let fileLists =
      preventiveValues?.files?.length > 0 ? [...preventiveValues?.files] : [];
    const readFiles = Array.from(fileList).map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => {
          fileLists = [...fileLists, { file: file, previewUrl: reader.result }];
          resolve();
        };
        reader.onerror = () => reject(reader.error);
        reader.readAsDataURL(file);
      });
    });
    Promise.all(readFiles)
      .then(() =>
        setPreventiveValues({ ...preventiveValues, files: fileLists })
      )
      .catch((error) => console.error("Error reading files: ", error));
  };

  const handleImageRemove = (ind) => {
    const reqFiles = preventiveValues?.files?.filter((fl, i) => i !== ind);
    setPreventiveValues({ ...preventiveValues, files: reqFiles });
  };

  return (
    <>
      <Grid container>
        <img
          src={require("../../../../assets/images/svg/download.svg").default}
          alt=""
          className="cursor w30h30 prev-down "
          onClick={() => setDownloadModVsble(true)}
        />
        {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
          <div className="flex-row ml20 mt20 flex-center">
            <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className="ml70">
              <div className="w50Per">
                <CustomTextField
                  placeholder="Search"
                  fullWidth
                  backgroundColor={AppColors.lightPink}
                  value={searchText}
                  handleChange={(e) => setSearchText(e.target.value)}
                />
              </div>
            </Grid>
            <div className="w20Per ml20">
              <Grid item xs={12} sm={12} md={3} lg={3} xl={3}>
                <div className="flex-row-ali-cen">
                  <div className="normal-height">
                    <CustomButton
                      text="Add"
                      smallBtn
                      onClick={() => setModVisible(true)}
                      grayBtn={!statusActive}
                      disabled={!statusActive}
                    />
                  </div>

                  <img
                    src={
                      require("../../../../assets/images/svg/download.svg")
                        .default
                    }
                    alt=""
                    className="cursor ml20 w30h30"
                    onClick={() => setDownloadModVsble(true)}
                  />
                </div>
              </Grid>
            </div>
            <Grid item xs={12} sm={12} md={2} lg={2} xl={2}>
              <CustomSelect
                select
                list={statusList}
                value={type}
                handleChange={(e) => setType(e?.target?.value)}
              />
            </Grid>
          </div>
        </Grid> */}
        <div className="w100Per">
          <div className="mh16Min">
            <Table
              columns={tableHeaders}
              datas={preventives?.data
                ?.map((item) => ({
                  ...item,
                  date: moment(item?.date).format("DD MMM YYYY"),
                  status: item?.status,
                }))
                .flat()
                ?.filter((pre) =>
                  type === "All" ? pre?.status : pre?.status === type
                )
                ?.filter(
                  (pre) =>
                    pre?.type
                      ?.toLowerCase()
                      .includes(searchText?.toLowerCase()) ||
                    pre?.name?.toLowerCase().includes(searchText?.toLowerCase())
                )}
              grey
              preventive
              onEdit={(e, editable) => handleEditModal(e, editable)}
              onDelete={(e) => {
                handleDelete(e);
              }}
              onClickFile={(e) => {
                if (e?.file?.length > 0) {
                  setAttachments(e?.file ?? []);
                  setAttachModVisible(true);
                }
              }}
              onClickViewBtn={(e) => handleViewPreventive(e)}
              page={page}
              rowsPerPage={itemsPerLoad}
              totalRecords={preventives?.totalRecords ?? 0}
              handleChangePage={handleChangePage}
              editHide={!statusActive}
              appointmentId={appointmentId}
            />
          </div>
        </div>
      </Grid>

      <CustomModal
        open={downloadModVsble}
        onClose={onDownloadModClose}
        header="Download"
        rightModal
        modalWidth={30}
      >
        <Grid container spacing={1} className="ph20">
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <Typography className="gray7 txt-semi-bold mb10">Type: </Typography>
            <CustomSelect
              select
              list={downloadTypeList}
              value={downType}
              handleChange={(e) => setDownType(e?.target?.value)}
            />
          </Grid>

          {/* <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomCheckbox
              label="Vaccination"
              checked={downloadTypes?.includes("vaccination")}
              onChange={(e) => handleChangeCheckboxValue("vaccination", e)}
            />
          </Grid>          
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomCheckbox
              label="Flea Treatment"
              checked={downloadTypes?.includes("fleaTreatment")}
              onChange={(e) => handleChangeCheckboxValue("fleaTreatment", e)}
            />
          </Grid>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <CustomCheckbox
              label="Deworming"
              checked={downloadTypes?.includes("deworming")}
              onChange={(e) => handleChangeCheckboxValue("deworming", e)}
            />
          </Grid> */}

          <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className="mt10">
            <CustomTextField
              name="startDate"
              label="Start Date"
              fullWidth
              handleChange={handleChangeDownValues}
              value={downloadValues?.startDate}
              mobileDate
            />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6} xl={6} className="mt10">
            <CustomTextField
              name="endDate"
              label="End Date"
              fullWidth
              handleChange={handleChangeDownValues}
              value={downloadValues?.endDate}
              mobileDate
            />
          </Grid>
          {typeNotSelected && (
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <FormHelperText error>
                Please select at lease 1 type to proceed
              </FormHelperText>
            </Grid>
          )}
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <div className="flex1-end mt20">
              <div className="w30Per">
                <CustomButton text="Preview" smallBtn onClick={handlePreview} />
              </div>
            </div>
          </Grid>
        </Grid>
      </CustomModal>

      <CustomModal
        open={preViewModVsble}
        onClose={onClosePreViewMod}
        header=""
        modal
        modalWidth={60}
      >
        <div className="ph10 scroll-70vh">
          <div ref={contentToPrint} className="p20">
            <div className="flex-row-ali-cen">
              <div className="w15Per">
                <img
                  src={clinicProfile?.image}
                  alt=""
                  className="img-h50 ml10"
                />
              </div>
              <div className="w70Per flex-center">
                <div className="flex-column">
                  <Typography className="flex-center blue-color font-bold fs18">
                    {/* Preventive History */}
                    Preventive Certificate
                  </Typography>
                  <Typography className="txt-regular black fs14 mt10 flex-center">
                    {previewSingleData?.length > 0
                      ? `${moment(previewSingleData?.[0]?.date).format(
                          "DD MMM YYYY"
                        )}`
                      : `${moment(new Date(downloadValues?.startDate)).format(
                          "DD MMM YYYY"
                        )} - ${moment(new Date(downloadValues?.endDate)).format(
                          "DD MMM YYYY"
                        )}`}
                  </Typography>
                </div>
              </div>
              <div className="w15Per">
                <div className="flex-end">
                  <div className="blu-back wh50 flex-center">
                    <img
                      src={require("../../../../assets/images/png/VetInstantLogo.png")}
                      alt=""
                      className="img-hw40"
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="br4brblue mt20">
              <div className="p10">
                <div className="flex-row-ali-cen">
                  <div className="w33Per">
                    <div className="flex-row-ali-cen">
                      <Typography className="blue-color font-bold fs14 capitalize">
                        Pet Name:
                      </Typography>
                      <Typography className="txt-regular black fs14 ml5">
                        {apntDet?.pet?.petName}
                      </Typography>
                    </div>
                    <div className="flex-row-ali-cen">
                      <Typography className="blue-color font-bold fs14">
                        Breed:
                      </Typography>
                      <Typography className="txt-regular black fs14 ml5 capitalize">
                        {apntDet?.pet?.breed}
                      </Typography>
                    </div>
                  </div>
                  <div className="w33Per">
                    <div className="flex-row-ali-cen">
                      <Typography className="blue-color font-bold fs14">
                        Gender:
                      </Typography>
                      <Typography className="txt-regular black fs14 ml5 capitalize">
                        {apntDet?.pet?.gender}
                      </Typography>
                    </div>
                    <div className="flex-row-ali-cen">
                      <Typography className="blue-color font-bold fs14">
                        DOB:
                      </Typography>
                      <Typography className="txt-regular black fs14 ml5">
                        {moment(apntDet?.pet?.dob).format("DD MMM YYYY")}
                      </Typography>
                    </div>
                  </div>
                  <div className="w33Per">
                    <div className="flex-row-ali-cen">
                      <Typography className="blue-color font-bold fs14 capitalize">
                        Parent Name:
                      </Typography>
                      <Typography className="txt-regular black fs14 ml5">
                        {apntDet?.pet?.userName}
                      </Typography>
                    </div>
                    <div className="flex-row-ali-cen">
                      <Typography className="blue-color font-bold fs14">
                        Contact:
                      </Typography>
                      <Typography className="txt-regular black fs14 ml5">
                        {apntDet?.pet?.userMobile}
                      </Typography>
                    </div>
                  </div>
                </div>
                <div className="ph10 mv10 blue-hor-split" />
                {downloadTypes?.includes("vaccination") &&
                  getPreventiveByType("vaccination")?.length > 0 && (
                    <>
                      <Typography className="font-bold blue-color fs14 mv5">
                        Vaccination
                      </Typography>
                      {renderRecord(getPreventiveByType("vaccination"))}
                    </>
                  )}
                {downloadTypes?.includes("deworming") &&
                  getPreventiveByType("deworming")?.length > 0 && (
                    <>
                      <Typography className="font-bold blue-color fs14 mv5">
                        Deworming
                      </Typography>
                      {renderRecord(getPreventiveByType("deworming"))}
                    </>
                  )}
                {downloadTypes?.includes("fleaTreatment") &&
                  getPreventiveByType("fleatreatment")?.length > 0 && (
                    <>
                      <Typography className="font-bold blue-color fs14 mv5">
                        Flea Treatment
                      </Typography>
                      {renderRecord(getPreventiveByType("fleatreatment"))}
                    </>
                  )}
              </div>
            </div>
          </div>
          <div className="flex-center mv20">
            <div className="w20Per">
              <CustomButton
                text="Download"
                onClick={() => handlePrint(null, () => contentToPrint.current)}
                // onClick={handleDownloadPreventive}
                smallBtn
              />
            </div>
          </div>
        </div>
      </CustomModal>

      <CustomModal
        open={modVisible}
        onClose={handleModClose}
        header={isEditModal ? "Edit" : "Add"}
        rightModal
        modalWidth={30}
      >
        <div className="scroll-80vh ph20">
          <Grid container spacing={2}>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-row-ali-cen">
                <Typography className="font-medium fs14">
                  Select your action
                </Typography>
                <span className="red-color ml2"> *</span>
              </div>
              <CustomCheckbox
                radio
                name="actionType"
                onChange={(e) =>
                  handleChangeValues("actionType", e?.target?.value)
                }
                radios={
                  ((apntDet?.appointment?.inpatient &&
                    apntDet?.appointment?.appointmentStatus !== "schedule") ||
                    apntDet?.appointment?.appointmentStatus ===
                      "consultation" ||
                    apntDet?.appointment?.appointmentStatus === "finalize") &&
                  preventiveValues?.editable
                    ? radioActionTypes
                    : radioActionScheduleOnly
                }
                defaultValue={preventiveValues?.actionType}
              />
              <div className="mbminus" />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Select
                list={preventiveTypes}
                value={preventiveValues?.type}
                name="type"
                label={nameExpan?.["type"]}
                select
                mandatoryField
                handleChange={(e, value) => handleChangeValues("type", value)}
                error={preventiveErrors?.type}
                helperText={preventiveHelpers?.type}
                disabled={isEditModal}
                search
              />
            </Grid>
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <Select
                list={getTypeBasedList()}
                value={preventiveValues?.name ? preventiveValues?.name : null}
                name="name"
                label={
                  preventiveValues?.type?.value === "vaccination"
                    ? "Vaccine Name"
                    : preventiveValues?.type?.value === "deworming"
                    ? "Deworming Name"
                    : "Treatment Name"
                }
                mandatoryField
                newSelect
                handleChange={(e) => {
                  handleChangeValues("name", e?.value, {
                    productId: e?.productId ?? null,
                    serviceId: e?.serviceId ?? null,
                    stockId: e?.stockId ?? null,
                  });
                }}
                error={preventiveErrors?.name}
                helperText={preventiveHelpers?.name}
                disabled={isEditModal}
              />
            </Grid>
            {preventiveValues?.actionType === "Administer" ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <Select
                  list={getBatchList()}
                  value={preventiveValues?.batchNo}
                  name="batchNo"
                  label="Batch Number"
                  mandatoryField
                  newSelect
                  handleChange={(e) => {
                    handleChangeValues("batchNo", e?.value, {
                      productId: e?.productId ?? null,
                      serviceId: e?.serviceId ?? null,
                      batchId: e?.batchId,
                    });
                  }}
                  error={preventiveErrors?.batchNo}
                  helperText={preventiveHelpers?.batchNo}
                  // disabled={isEditModal}
                />
              </Grid>
            ) : null}
            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomTextField
                name="dueDate"
                label={nameExpan?.["dueDate"]}
                labelTop
                fullWidth
                handleChange={(e) =>
                  handleChangeValues("dueDate", e?.target?.value)
                }
                value={preventiveValues?.dueDate}
                mobileDate
                mandatoryField
                disabled={preventiveValues?.actionType === "Administer"}
                error={preventiveErrors?.dueDate}
                helperText={preventiveHelpers?.dueDate}
              />
            </Grid>

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <CustomTextField
                label={nameExpan?.["remarks"]}
                placeholder="Remarks"
                name="remarks"
                fullWidth
                handleChange={(e) =>
                  handleChangeValues("remarks", e?.target?.value)
                }
                value={preventiveValues?.remarks}
                multiline
                error={preventiveErrors?.remarks}
                helperText={preventiveHelpers?.remarks}
              />
            </Grid>
            {preventiveValues?.type?.value === "vaccination" ? (
              <div className="mt20">
                {preventiveValues?.files?.length > 0 ? (
                  <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                    <FilesWithCloseButton
                      files={preventiveValues?.files}
                      onClickFile={(i, file) => handleImageRemove(i)}
                    />
                  </Grid>
                ) : null}
                <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                  <CustomUpload
                    onUploadFile={onUploadFile}
                    multipleNew
                    multiFiles
                  />
                </Grid>
              </div>
            ) : null}
            {preventiveValues?.actionType === "Administer" ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <div className="flex-row-ali-cen">
                  <Typography className="font-medium fs14">
                    Schedule for the next dosage?
                  </Typography>
                  <span className="red-color ml2"> *</span>
                </div>
                <CustomCheckbox
                  radio
                  name="nextDosage"
                  onChange={(e) =>
                    handleChangeValues("nextDosage", e?.target?.value)
                  }
                  radios={[
                    { label: "Yes", value: "Yes" },
                    { label: "No", value: "No" },
                  ]}
                  defaultValue={preventiveValues?.nextDosage}
                />
                <div className="mbminus" />
              </Grid>
            ) : null}
            {preventiveValues?.actionType === "Administer" &&
            preventiveValues?.nextDosage === "Yes" ? (
              <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
                <CustomTextField
                  name="nextDueDate"
                  label={nameExpan?.["nextDueDate"]}
                  fullWidth
                  handleChange={(e) =>
                    handleChangeValues("nextDueDate", e?.target?.value)
                  }
                  value={preventiveValues?.nextDueDate}
                  mobileDate
                  mandatoryField
                  labelTop
                  minDate={datePlusOneDay}
                  error={preventiveErrors?.nextDueDate}
                  helperText={preventiveHelpers?.nextDueDate}
                />
              </Grid>
            ) : null}

            <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
              <div className="flex-center">
                <div>
                  <CustomButton text="Save" smallBtn onClick={handleSave} />
                </div>
              </div>
            </Grid>
          </Grid>
        </div>
      </CustomModal>

      <CustomModal
        open={conModVsble}
        onClose={handleCloseConMod}
        center
        modalWidth={30}
        headerShown={false}
        modal
      >
        <Typography className="flex-center txt-semi-bold fs14">
          You are about to administer {preventiveValues?.name?.value} before the
          set
        </Typography>
        <Typography className="flex-center txt-semi-bold fs14">
          due date {moment(preventiveValues?.oldDueDate)?.format("DD-MMM-YYYY")}
          .
        </Typography>

        <Typography className="flex-center txt-regular fs14 mt10">
          Are you sure you want to proceed
        </Typography>
        <Typography className="flex-center txt-regular fs14">
          with this early administration?
        </Typography>

        <div className="flex-center mb10 mt15">
          <div>
            <CustomButton
              redBtn
              text="Proceed"
              onClick={handleApiCall}
              smallBtn
            />
          </div>
          <div className="ml10">
            <CustomButton text="Cancel" onClick={handleConCancel} smallBtn />
          </div>
        </div>
      </CustomModal>
      <CustomModal
        open={delModVsble}
        onClose={handleCloseDelMod}
        header="Delete Preventive"
        modal
        modalWidth={40}
      >
        <Typography className="txt-regular fs16 ml10">
          Are you sure you want to delete the preventive?
        </Typography>
        <Grid item xs={12} sm={12} md={6} lg={6} xl={6}>
          <div className="clinic-mod-btn-pos mb10 mt15">
            <div className="mr10">
              <CustomButton
                text="Yes"
                redBtn
                onClick={handleDeletePreventive}
                smallBtn
              />
            </div>
            <div className="ml10">
              <CustomButton text="No" onClick={handleCloseDelMod} smallBtn />
            </div>
          </div>
        </Grid>
      </CustomModal>
    </>
  );
};

export default Preventive;
